import React from "react";
import PropTypes from "prop-types";
import "./FormHeader.css";

const FormHeader = ({
  title,
  children,
  className = "form-header",
  ...props
}) => {
  return (
    <div
      className={`form-header ${className}`}
      style={props.style}
      onClick={props.onClick}
      {...props}
    >
      <h2>{title}</h2>
      <span className="form-header__child">{children}</span>
    </div>
  );
};

FormHeader.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.element,
  className: PropTypes.string
};

export default FormHeader;
